import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { mask, unMask } from "../../../../utils/MascaraDeCampos";
import { Button, notification, Spin, Tag, Tooltip, Typography } from "antd";
import Icon, { LoadingOutlined } from "@ant-design/icons";
import { FaDownload, FaExclamation, FaExclamationCircle, FaSearch } from "react-icons/fa";
import { convertDataUSParaBrasilEHora } from "../../../../services/Conversores";
import moment from "moment";
import { useGetColumnSearchPropsData } from "../../../../hooks/FilterTable/date";
import { useGetColumnSearchProps } from "../../../../hooks/FilterTable/string";
import { SairDoSistema } from "../../../../services/LStorage/SairSistema";
import { EmitirErro } from "../../../../services/EmitirErro";
import { useNavigate } from "react-router-dom";
import CongelamentoUnicoService from "../../../../services/http/services/CongelamentoPorCNPJ/CongelamentoUnicoService";
import { IReqCongelamentoUnico, IReqItensCongelamentoUnicoModal } from "./interface";
import { isValidCNPJ } from "../../../../utils/validations";
import { urlHttpGovSocketIo } from "../../../../services/urls";
import { io } from "socket.io-client";

// @ts-ignore
import ImgUpLike from './../../../../assets/imagens/upLike.png';
// @ts-ignore
import ImgDownLike from './../../../../assets/imagens/downLike.png';
import { formatarTextoComAcentosCompleto } from "../Extrato/utils";

const { Text } = Typography;

const IconSerach = (props: any) => <Icon {...props} component={FaSearch} ></Icon>
const IconDownload = (props: any) => <Icon {...props} component={FaDownload} ></Icon>
const IconFaExclamationCircle = (props: any) => <Icon {...props} component={FaExclamation} ></Icon>

const statusOptions = [
    {
        text: 'Finalizado',
        value: 'finalizado',
        color: '#17751b',
    },
    {
        text: 'Em andamento',
        value: 'em_andamento',
        color: '#2db7f5',
    },
    {
        text: 'Erro',
        value: 'erro',
        color: '#930',
    },
];

export const useAbaCongelamento = () => {

    const navigate = useNavigate();

    const refContagemDoFiltro = useRef<Array<any>>([]);

    const refAbortController = useRef<AbortController>();

    const refsocket = useRef<any>(null);

    const [valueCNPJ, setValueCNPJ] = useState<string>()
    const [errorCNPJ, setErrorCNPJ] = useState<boolean>(false)

    const [dadosTabelaState, setDadosTabelaState] = useState<Array<IReqCongelamentoUnico>>([]);
    const [loading, setLoading] = useState(false);

    const [visibleModal, setVisibleModal] = useState(false);
    const [isCertidoesModalVisible, setIsCertidoesModalVisible] = useState(false);

    const [loadingCertidoesCongelamnetoModal, setLoadingCertidoesCongelamnetoModal] = useState(false);
    const refContagemDoFiltroCertidoesCongelamnetoModal = useRef<Array<any>>([]);
    const [dadosTabelaStateCertidoesCongelamnetoModal, setDadosTabelaStateCertidoesCongelamnetoModal] = useState<Array<IReqItensCongelamentoUnicoModal>>([]);
    const refLineTableClikedOpenModal = useRef<IReqCongelamentoUnico>();

    useEffect(() => () => {
        refAbortController.current?.abort();
        desconectarSocker()
    }, []);

    const handleOpenCertidoesModal = useCallback(() => {
        setIsCertidoesModalVisible(true);
    }, []);

    const handleCloseCertidoesModal = useCallback(() => {
        setIsCertidoesModalVisible(false);
    }, []);

    const desconectarSocker = useCallback((): void => {
        //desconectar socket
        if (refsocket.current) {

            refsocket.current.close();
            refsocket.current = null

        }
    }, [])

    const socketConnection = useCallback((): void => {

        const socket = io(urlHttpGovSocketIo);


        refsocket.current = socket
        socket.on('connect', () => {
            socket.emit("congelamento_cnpj", "congelamento_cnpj");
            socket.on('congelamento_cnpj', data => {

                setDadosTabelaState((prevState) => {
                    const currentData = [...prevState];

                    const congelamentoIndex = currentData.findIndex((e) => e.id === data.congelamentoId);

                    if (congelamentoIndex < 0) {
                        return currentData;
                    }

                    currentData[congelamentoIndex].status = data.status;

                    return currentData;
                });

                setDadosTabelaStateCertidoesCongelamnetoModal((prevState) => {
                    if (!prevState.length) {
                        return prevState;
                    }

                    const currentData = [...prevState];

                    const arquivoIndex = currentData.findIndex((e) => e.id === data.arquivo.id);

                    if (arquivoIndex < 0) {
                        return currentData;
                    }

                    currentData[arquivoIndex] = {
                        certidaoCongelamentoCnpj: currentData[arquivoIndex].certidaoCongelamentoCnpj,
                        ...data.arquivo
                    };

                    return currentData;
                });
            })

        });

    }, []);

    //setando dados das cidades no selected
    const buscaCongelamentosModal = useCallback((idCongelamento: string) => {

        const requestAsync = async () => {
            try {
                setLoadingCertidoesCongelamnetoModal(true);

                const response = await CongelamentoUnicoService.getItensCongelamento(idCongelamento, refAbortController.current?.signal);

                setDadosTabelaStateCertidoesCongelamnetoModal(response);

                setVisibleModal(true)
                setLoadingCertidoesCongelamnetoModal(false);

            } catch (error) {

                let msgErro: any = (error as Error);
                setLoadingCertidoesCongelamnetoModal(false);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'municipios_dkwdfaiweyi')
                }


            }
        }

        requestAsync();

    }, []);

    //setando dados das cidades no selected
    const buscaCongelamentos = async () => {

        try {
            setLoading(true);

            const response = await CongelamentoUnicoService.getCongelamentos(refAbortController.current?.signal);

            setDadosTabelaState(response);


            setLoading(false);

        } catch (error) {

            let msgErro: any = (error as Error);
            setLoading(false);

            if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                SairDoSistema();
                notification.error({
                    message: 'Sessão expirada',
                    description:
                        'Sua sessão expirou, realize o login novamente!',
                });
                navigate('/');
            } else {
                EmitirErro(error, true, 'municipios_dkwdfaiweyi')
            }


        }

    }

    useEffect(() => {

        refAbortController.current = new AbortController();

        buscaCongelamentos();

        socketConnection();

    }, []);

    const onChangeInputCNPJ = useCallback((e: any) => {
        const originalValue = unMask(e.target.value);
        const maskedValue = mask(originalValue, [
            "99.999.999/9999-99"
        ]);

        setValueCNPJ(maskedValue);

        if (maskedValue.length > 17) {
            setErrorCNPJ(!isValidCNPJ(originalValue))
            return
        }

        if (maskedValue.length === 0) {
            setErrorCNPJ(false)
            return
        }


    }, []);

    const onClickGerarCertidoes = useCallback(() => {

        if (!valueCNPJ) {
            notification.warning({
                message: 'Obrigatório',
                description:
                    'Por favor, preencha o CNPJ.',
            });
            return
        }

        if (errorCNPJ) {
            notification.error({
                message: 'Erro',
                description:
                    'Por favor, preencha o CNPJ válido.',
            });
            return
        }

        const requestAsync = async () => {
            try {
                setLoading(true);

                await CongelamentoUnicoService.postCongelamentoCertidoes(unMask(valueCNPJ), refAbortController.current?.signal);

                buscaCongelamentos();

                setValueCNPJ(undefined)
                // setLoading(false);

            } catch (error) {

                let msgErro: any = (error as Error);
                setLoading(false);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'municipios_dkwdfaiweyi_certidoes')
                }


            }
        }

        requestAsync();

    }, [valueCNPJ, errorCNPJ]);

    const onClickGerarCertidoesFINEP = useCallback(() => {

        if (!valueCNPJ) {
            notification.warning({
                message: 'Obrigatório',
                description:
                    'Por favor, preencha o CNPJ.',
            });
            return
        }

        if (errorCNPJ) {
            notification.error({
                message: 'Erro',
                description:
                    'Por favor, preencha o CNPJ válido.',
            });
            return
        }

        const requestAsync = async () => {
            try {
                setLoading(true);

                await CongelamentoUnicoService.postCongelamentoCertidoesFinep(unMask(valueCNPJ), refAbortController.current?.signal);

                buscaCongelamentos();

                setValueCNPJ(undefined)
                // setLoading(false);

            } catch (error) {

                let msgErro: any = (error as Error);
                setLoading(false);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'municipios_dkwdfaiweyi_finep')
                }


            }
        }

        requestAsync();

    }, [valueCNPJ, errorCNPJ]);

    const clickOpenModal = useCallback((record: IReqCongelamentoUnico) => {
        refLineTableClikedOpenModal.current = record
        buscaCongelamentosModal(record.id)
    }, []);

    const clickCancelModal = useCallback(() => {
        refLineTableClikedOpenModal.current = undefined
        setVisibleModal(false)
    }, []);

    const maskCNPJ = useCallback((value: any) => {
        if (!value) return '';

        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "99.999.999/9999-99"
        ]);

        return maskedValue

    }, []);

    const handleClickDownloadUnicoFileLinkAssinado = useCallback((record?: IReqItensCongelamentoUnicoModal) => {

        const requestAsync = async () => {
            try {
                if (!record) {
                    notification.error({
                        message: 'Não foi possível baixar.',
                        description:
                            'Tente novamente mais tarde.',
                    });
                    return
                }

                if (!record.arquivo) {
                    notification.error({
                        message: 'Não foi possível baixar.',
                        description:
                            'Tente novamente mais tarde.',
                    });
                    return
                }

                setLoadingCertidoesCongelamnetoModal(true);

                const response = await CongelamentoUnicoService.getCongelamentosBaixarUnico(
                    record?.congelamentoCnpjId,
                    record.arquivo,
                    refAbortController.current?.signal
                );

                const link = document.createElement('a');
                link.href = response?.signedUrl;
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();


                setLoadingCertidoesCongelamnetoModal(false);

            } catch (error) {

                let msgErro: any = (error as Error);
                setLoadingCertidoesCongelamnetoModal(false);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'municipios_dkwdfaiweyi')
                }


            }
        }

        requestAsync();
    }, [])

    const handleClickDownloadAllFileZIP = useCallback((record?: IReqCongelamentoUnico) => {

        const requestAsync = async () => {
            try {

                if (!record) {
                    notification.error({
                        message: 'Não foi possível baixar.',
                        description:
                            'Tente novamente mais tarde.',
                    });
                    return
                }

                setLoadingCertidoesCongelamnetoModal(true);

                const response = await CongelamentoUnicoService.getCongelamentosBaixarTodos(record.id, refAbortController.current?.signal);

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${record.tipo}_${record.cnpj}.zip`);
                document.body.appendChild(link);
                link.click();


                setLoadingCertidoesCongelamnetoModal(false);

            } catch (error) {

                let msgErro: any = (error as Error);
                setLoadingCertidoesCongelamnetoModal(false);

                if (msgErro?.message === 'USUáRIO NãO AUTORIZADO.') {
                    SairDoSistema();
                    notification.error({
                        message: 'Sessão expirada',
                        description:
                            'Sua sessão expirou, realize o login novamente!',
                    });
                    navigate('/');
                } else {
                    EmitirErro(error, true, 'municipios_dkwdfaiweyi')
                }


            }
        }

        requestAsync();
    }, [])

    const tipos = useMemo(() => {
        const tiposArray = dadosTabelaState.reduce((prev, current) => {
            return [
                ...prev,
                current.tipo,
            ]
        }, [] as string[]);

        const tiposUnicos = Array.from(new Set(tiposArray));

        const tiposFormatados = tiposUnicos.map((e) => ({
            value: e,
            label: formatarTextoComAcentosCompleto(e),
        }));

        return tiposFormatados;
    }, [dadosTabelaState]);

    const columns = [
        {
            title: 'CNPJ',
            dataIndex: 'cnpj',
            ...useGetColumnSearchProps('cnpj'),
            width: '10%',
            sorter: (a: any, b: any) => a?.cnpj?.localeCompare(b?.cnpj),
            showSorterTooltip: false,
            render: (cnpj: any) => {

                return maskCNPJ(cnpj)
            },
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo',
            width: '10%',
            sorter: (a: any, b: any) => a.tipo.localeCompare(b.tipo),
            showSorterTooltip: false,
            filters: tipos?.map((e) => ({
                text: e.label || '',
                value: e.value || '',
            })),
            onFilter: (value: any, record: any) => {
                const columnValue = record.tipo;
                return columnValue === value;
            },
            render: (val: string) => {
                return (
                    <Text>{formatarTextoComAcentosCompleto(val)}</Text>
                )
            },
        },
        {
            title: 'Data',
            dataIndex: 'createdAt',
            ...useGetColumnSearchPropsData('createdAt'),
            width: '2%',
            sorter: (a: any, b: any) => {

                let aMonMen: any = null
                let bMonMen: any = null
                if (a.createdAt) {
                    aMonMen = moment(a.createdAt).unix()
                } else {
                    aMonMen = 0
                }
                if (b.createdAt) {
                    bMonMen = moment(b.createdAt).unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            showSorterTooltip: false,
            // sorter: (a: any, b: any) => a.update_at.localeCompare(b.update_at),
            render: (data: any) => {

                return (
                    convertDataUSParaBrasilEHora(data)
                )
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            // ...getColumnSearchProps('status'),
            width: '4%',
            filters: statusOptions,
            onFilter: (value: any, record: any) => {
                return record.status?.indexOf(value) === 0;
            },
            render: (val: any) => {
                const statusEncontrado = statusOptions.find(statusItem => statusItem.value === val);

                return (
                    <span>
                        <Tag color={statusEncontrado?.color}>
                            {statusEncontrado ? statusEncontrado.text : val}
                        </Tag>
                    </span>
                )
            },
        },
        {
            title: 'Usuário',
            dataIndex: 'usuario',
            // ...useGetColumnSearchProps('usuario'),
            width: '10%',
            // sorter: (a: any, b: any) => a?.usuario?.localeCompare(b?.usuario),
            showSorterTooltip: false,
            render: (usuario: any) => {

                return usuario?.nome
            },
        },
        {
            title: 'Ações',
            dataIndex: 'id',
            width: '2%',
            showSorterTooltip: false,
            render: (arquivo: any, record: any) => {
                let baixarTodos = false
                switch (record?.status) {
                    case "finalizado":
                        baixarTodos = true;
                        break;
                    case "erro":
                        baixarTodos = true;
                        break;
                    case "em_andamento":
                        baixarTodos = false;
                        break;

                    default:
                        baixarTodos = false
                        break;
                }
                return (
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row'
                    }}>
                        <Tooltip title="Visualizar" color="blue">
                            <Button
                                type="primary"
                                // className="CertidoesCongelamento_BotaoAzulMarinho_edfrgjkfbrgqrepiujhnbw"
                                style={{
                                    marginRight: 5
                                }}
                                // disabled={!hasSelectedAdd}
                                onClick={() => clickOpenModal(record)}
                            >
                                {/* <FileSearchOutlined /> */}
                                <IconSerach style={{ fontSize: 14 }} />
                            </Button>
                        </Tooltip>
                        {
                            baixarTodos ?
                                <>
                                    <Tooltip title="Baixar Todos" color="#30912d">
                                        <Button
                                            type="primary"
                                            className="CertidoesCongelamento_BotaoVerde_edfrgjkfbrgqrepiujhnbw"
                                            onClick={() => handleClickDownloadAllFileZIP(record)}
                                        >
                                            <IconDownload />
                                        </Button>
                                    </Tooltip>
                                </>
                                :
                                <></>
                            // <Text
                            //     style={{
                            //         fontWeight: 'bold',
                            //         color: record.status ? 'red' : 'green'
                            //     }}
                            // >
                            //     {'Não há PDF'}
                            // </Text>
                        }

                    </div>
                )
            },
        },
    ];

    const columnsCertidoesCongelamnetoModal = [
        {
            title: 'Item',
            dataIndex: 'certidaoCongelamentoCnpj',
            // ...useGetColumnSearchProps('certidaoCongelamentoCnpj'),
            width: '0.5%',
            // sorter: (a: any, b: any) => a.certidaoCongelamentoCnpj.localeCompare(b.certidaoCongelamentoCnpj),
            showSorterTooltip: false,
            render: (certidao: any, record: any) => {
                return (
                    certidao?.idItem
                )
            }
        },
        {
            title: 'Nome',
            dataIndex: 'certidaoCongelamentoCnpj',
            // ...useGetColumnSearchProps('certidaoCongelamentoCnpj'),
            width: '10%',
            // sorter: (a: any, b: any) => a.certidaoCongelamentoCnpj.localeCompare(b.certidaoCongelamentoCnpj),
            showSorterTooltip: false,
            render: (certidao: any, record: any) => {
                return (
                    certidao?.nome
                )
            }
        },
        {
            title: 'Status',
            dataIndex: 'pendente',
            // ...useGetColumnSearchProps('certidaoCongelamentoCnpj'),
            width: '1%',
            // sorter: (a: any, b: any) => a.certidaoCongelamentoCnpj.localeCompare(b.certidaoCongelamentoCnpj),
            showSorterTooltip: false,
            render: (pendente: any, record: any) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        {
                            record.alerta ?
                                <div
                                    style={{
                                        border: '2px solid #df9e36',
                                        borderRadius: '50%',
                                        padding: '3px',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginLeft: 5
                                    }}
                                >
                                    <IconFaExclamationCircle
                                        style={{
                                            color: '#df9e36',
                                            fontSize: 13,
                                        }}
                                    />
                                </div>
                                :
                                pendente === null ?
                                    <Text
                                        style={{
                                            marginLeft: 10
                                        }}
                                    >{'--'}</Text>
                                    :
                                    <img style={{
                                        width: 24,
                                        marginLeft: 5
                                    }} src={pendente ? ImgDownLike : ImgUpLike} />

                        }
                    </div>
                )
            },
        },
        {
            title: 'Baixar',
            dataIndex: 'status',
            width: '2%',
            showSorterTooltip: false,
            render: (status: any, record: any) => {
                return (
                    <div className='naoElinha'>
                        {
                            status === null ?
                                <Spin
                                    indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
                                />
                                :
                                status === true ?
                                    <Button
                                        type="primary"
                                        onClick={() => handleClickDownloadUnicoFileLinkAssinado(record)}
                                    >
                                        {'Baixar '}<IconDownload />
                                    </Button>
                                    :
                                    <Text
                                        style={{
                                            fontWeight: 'bold',
                                            color: 'red'
                                            // color: status ? 'red' : 'green'
                                        }}
                                    >
                                        {'Não foi possível baixar!'}
                                    </Text>
                        }

                    </div>
                )
            },
        },
    ];

    return {
        onChangeInputCNPJ,
        valueCNPJ,
        onClickGerarCertidoes,
        onClickGerarCertidoesFINEP,
        refContagemDoFiltro,
        columns,
        dadosTabelaState,
        visibleModal,
        clickCancelModal,
        loadingCertidoesCongelamnetoModal,
        refContagemDoFiltroCertidoesCongelamnetoModal,
        dadosTabelaStateCertidoesCongelamnetoModal,
        columnsCertidoesCongelamnetoModal,
        refLineTableClikedOpenModal,
        handleClickDownloadAllFileZIP,
        loading,
        errorCNPJ,
        isCertidoesModalVisible,
        handleOpenCertidoesModal,
        handleCloseCertidoesModal,
    }
}
